import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import styles from './SponsorDropoff.module.css';
import { CustomTextField } from '../../customs/CustomTextField';
import SponsorDropoffHeader from './SponsorDropoffHeader';
import GlassCard from '../../customs/GlassCard';

import { useForm } from 'react-hook-form';

const DropoffSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
  } = useForm();

  const onSubmit = (value) => {
    navigate(`${location.pathname}/${value.dropoffId.trim()}`);
  };

  const onEnterSubmit = (dropoffId) => {
    navigate(`${location.pathname}/${dropoffId.trim()}`);
  };

  return (
    <StyledEngineProvider injectFirst>
      <SponsorDropoffHeader />

      <Container className={styles.searchContainer}>
        <GlassCard className={styles.searchCard}>
          <Typography
            variant='h6'
            component='h6'
            gutterBottom
            textAlign='center'
            sx={{ marginBottom: '2rem' }}
          >
            Drop-off Information Search
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row' }}
            justifyContent='center'
            alignItems='center'
            spacing={{ xs: 2, sm: 2, md: 4 }}
          >
            <Box width='100%'>
              <CustomTextField
                label='Confirmation ID'
                type='text'
                variant='outlined'
                focusColor='#FDB91B'
                fullWidth
                {...register('dropoffId', { required: true })}
                helperText={
                  errors?.dropoffId?.type === 'required' &&
                  'Angel Confirmation ID required'
                }
                onKeyUp={(e) => {
                  if (e.key === 'Enter' || e.code === 'Enter')
                    onEnterSubmit(getValues('dropoffId'));
                }}
              />
            </Box>
            <Box>
              <Button
                type='submit'
                color='secondary'
                size='large'
                variant='contained'
                onClick={handleSubmit(onSubmit)}
              >
                Search
              </Button>
            </Box>
          </Stack>
        </GlassCard>
      </Container>
    </StyledEngineProvider>
  );
};

export default DropoffSearch;
